
define('template!editPimOptionTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="code">\n    ';
 if(enableOnOff) { ;
__p += '\n    <input type="checkbox" class="cbx-enable-opt" ' +
((__t = ( activated===false?'':'checked' )) == null ? '' : __t) +
' />\n    ';
 } ;
__p += '\n    ' +
((__t = ( code )) == null ? '' : __t) +
'\n</div>\n<div class="name">' +
((__t = ( name )) == null ? '' : __t) +
' <div class="glossary-dt-value opt-name-region"></div></div>\n<div class="color">\n    ';
 if(color !== '') { ;
__p += '\n        <div class="color-round" style="background-color:' +
((__t = ( color )) == null ? '' : __t) +
'"></div>\n    ';
 } ;
__p += '\n</div>\n';

    var css = '';
    if(allowUpload) {
        css = 'context-menu-option';
    }
;
__p += '\n<div class="images">\n    ';
 _.each(images, function (image, index) { ;
__p += '\n        <div class=\'image ' +
((__t = ( image.uid ? 'is-own-image' : '' )) == null ? '' : __t) +
'\'>\n            ';
 if (defaultIndexPicture === (index + 1)) { ;
__p += '\n            <i class="mdi-action-bookmark" style="position:absolute; font-size: 13px; color: green;"></i>\n            ';
 } ;
__p += '\n            <img data-index="' +
((__t = ( index+1 )) == null ? '' : __t) +
'" data-view="' +
((__t = ( image.index )) == null ? '' : __t) +
'" data-uid="' +
((__t = ( image.uid || '' )) == null ? '' : __t) +
'"\n                 data-link="' +
((__t = ( image.url )) == null ? '' : __t) +
'" class="jq-picture js-image-cell ' +
((__t = ( css )) == null ? '' : __t) +
'" src="' +
((__t = ( image.url )) == null ? '' : __t) +
'"\n                 ';
 if (image.uid) { ;
__p += 'title="' +
__e( image.replaces ? 'Your image, in place of the supplier\'s' : 'Your image' ) +
'"';
 } ;
__p += '/>\n            ';
 if (image.uid) { ;
__p += '\n            <i class="mdi-social-person opt-own-image-badge"></i>\n            ';
 } ;
__p += '\n            ';
 if (placed && placed[index]) { ;
__p += '\n            <span class="pim-placed-badge ' +
((__t = ( placed[index].own ? 'is-own' : '' )) == null ? '' : __t) +
'" title="' +
__e( placed[index].title ) +
'">' +
((__t = ( placed[index].count )) == null ? '' : __t) +
'</span>\n            ';
 } ;
__p += '\n        </div>\n    ';
 });;
__p += '\n    ';
 if (allowUpload) { ;
__p += '\n    <div class="opt-image-upload">\n        <label for="uploadOptImage-' +
((__t = ( pimId )) == null ? '' : __t) +
'" class="upload-title"\n               title="Add images to this option, for your webshop and editor only. Right-click a picture to replace it.">\n            <i class="mdi-image-add-to-photos clickable"></i>\n        </label>\n        <input id="uploadOptImage-' +
((__t = ( pimId )) == null ? '' : __t) +
'" type="file" multiple accept="image/png,image/jpeg,image/gif,image/webp"\n               class="hidden js-upload-opt-image"/>\n    </div>\n    ';
 } ;
__p += '\n</div>\n';

}
return __p
};});

